import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isPage: true,
    newsList: [
      {
        time: "2026-10-28",
        txt: "东风南方保险代理有限公司关于广西分公司主要负责人变更的公告"
      },
      {
        time: "2026-10-20",
        txt: "东风南方保险代理有限公司关于湖北分公司主要负责人变更的公告 "
      },
      {
        time: "2025-10-28",
        txt: "东风南方保险代理有限公司关于贵州分公司主要负责人变更的公告 "
      },
      {
        time: "2025-10-14",
        txt: "东风南方保险代理有限公司关于修订公司章程的公告   "
      },
      {
        time: "2025-08-28",
        txt: "东风南方保险代理有限公司河北分公司关于住所变更的公告"
      },
      {
        time: "2025-03-13",
        txt: "东风南方保险代理有限公司浙江分公司关于住所变更的公告"
      },
      {
        time: "2024-10-08",
        txt: "东风南方保险代理有限公司关于修订公司章程的公告  "
      },
      {
        time: "2024-07-01",
        txt: "东风南方保险代理有限公司关于茂名分公司主要负责人变更的公告"
      },
      {
        time: "2024-03-18",
        txt: "东风南方保险代理有限公司关于修订公司章程的公告 "
      },
      {
        time: "2023-11-16",
        txt: "东风南方保险代理有限公司关于云南分公司主要负责人变更的公告  "
      },
      {
        time: "2023-10-12",
        txt: "东风南方保险代理有限公司关于河北分公司主要负责人变更的公告 "
      },
      {
        time: "2023-08-28",
        txt: "东风南方保险代理有限公司关于江苏分公司主要负责人变更的公告 "
      },
      {
        time: "2023-07-21",
        txt: "东风南方保险代理有限公司关于湖北分公司主要负责人变更的公告"
      },
      {
        time: "2023-06-26",
        txt: "东风南方保险代理有限公司北京分公司关于住所变更的公告"
      },
      {
        time: "2023-06-15",
        txt: "东风南方保险代理有限公司深圳分公司关于住所变更的公告"
      },
      {
        time: "2023-02-21",
        txt: "东风南方保险代理有限公司2022年度消费者权益保护工作报告"
      },
      {
        time: "2022-12-28",
        txt: "东风南方保险代理有限公司关于换发《保险中介许可证》的公告"
      },
      {
        time: "2022-11-30",
        txt: "东风南方保险代理有限公司关于变更住所暨修订公司章程的公告"
      },
      {
        time: "2022-11-30",
        txt: "关于本公司营业场所地址变更的公示"
      },
      {
        time: "2022-11-25",
        txt: "客户告知书2022（官网版）"
      },
      {
        time: "2022-04-16",
        txt: "东风南方保险代理有限公司关于云南分公司主要负责人变更的公告 "
      },
      {
        time: "2022-04-02",
        txt: "东风南方保险代理有限公司关于总经理变更的公告 "
      },
      {
        time: "2022-01-25",
        txt: "东风南方保险代理有限公司关于山东分公司主要负责人变更的公告"
      },
      {
        time: "2021-11-23",
        txt: "东风南方保险代理有限公司关于重庆分公司主要负责人变更的公告"
      },
      {
        time: "2021-09-17",
        txt: "东风南方保险代理有限公司关于撤销沿江中路营业部的公告"
      },
      {
        time: "2021-05-17",
        txt: "东风南方保险代理有限公司关于深圳分公司主要负责人变更的公告"
      },
      {
        time: "2021-04-25",
        txt: "东风南方保险代理有限公司关于东莞分公司主要负责人变更的公告"
      },
      {
        time: "2021-02-18",
        txt: "东风南方保险代理有限公司关于广州分公司主要负责人变更的公告"
      },
      {
        time: "2020-12-17",
        txt: "东风南方保险代理有限公司关于江苏分公司主要负责人变更的公告"
      },
      {
        time: "2020-09-30",
        txt: "东风南方保险代理有限公司关于设立湖北分公司的公告"
      },
      {
        time: "2020-09-30",
        txt: "东风南方保险代理有限公司关于设立广西分公司的公告"
      },
      {
        time: "2020-09-21",
        txt: "东风南方保险代理有限公司关于执行董事变更的公告"
      },
      {
        time: "2020-07-23",
        txt: "东风南方保险代理有限公司关于修订公司章程的公告"
      },
      {
        time: "2020-07-22",
        txt: "东风南方保险代理有限公司关于河北分公司主要负责人变更的公告"
      },
      {
        time: "2020-07-01",
        txt: "东风南方保险代理有限公司关于沿江中路营业部主要负责人变更的公告"
      },
      {
        time: "2020-06-18",
        txt: "东风南方保险代理有限公司关于茂名分公司主要负责人任命的公告"
      },
      {
        time: "2019-12-16",
        txt: "东风南方保险代理有限公司关于海南分公司主要负责人变更的公告"
      },
      {
        time: "2019-12-12",
        txt: "东风南方保险代理有限公司关于云南分公司主要负责人变更的公告"
      },
      {
        time: "2019-11-11",
        txt: "东风南方保险代理有限公司关于浙江分公司主要负责人变更的公告"
      },
      {
        time: "2019-04-22",
        txt: "东风南方保险代理有限公司关于设立沿江中路营业部的公告"
      },
      {
        time: "2019-02-19",
        txt: "东风南方保险代理有限公司关于贵州分公司主要负责人变更的公告"
      },
      {
        time: "2018-12-14",
        txt: "东风南方保险代理有限公司关于四川分公司主要负责人任命的公告"
      },
      {
        time: "2018-11-02",
        txt: "东风南方保险代理有限公司关于设立上海分公司的公告"
      },
      {
        time: "2018-09-20",
        txt: "东风南方保险代理有限公司关于设立辽宁分公司的公告"
      },
      {
        time: "2018-05-08",
        txt: "东风南方保险代理有限公司关于总经理变更的公告"
      },
    ]
  },
  getters: {
  },
  mutations: {
    SET_ISPAGE(state, payload) {
      state.isPage = payload
    },
  },
  actions: {
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js